import { render, staticRenderFns } from "./robofinder_app.vue?vue&type=template&id=031c40ae&scoped=true"
import script from "./robofinder_app.vue?vue&type=script&lang=js"
export * from "./robofinder_app.vue?vue&type=script&lang=js"
import style0 from "./robofinder_app.vue?vue&type=style&index=0&id=031c40ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c40ae",
  null
  
)

export default component.exports